import styles from './FJAiVideoDubRightStatusBox.module.less';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJProgressStatus from '../../../../common/components/FJProgressStatus/FJProgressStatus';
import FJConstant from '../../../../constants/FJConstant';

const FJAiVideoDubRightStatusBox = ({
    isShow,
    status = FJConstant.START,
    thumbnailUrl,
    progress,
    generateAllTime,
    cancel,
    retry,
}) => {
    return (
        <div className={classNames(styles.status_box, { [styles.show]: isShow })}>
            <FJProgressStatus
                progress={progress}
                allTime={generateAllTime}
                cancelProgress={cancel}
                status={status}
                retry={retry}
                isShowControl={false}
                thumbnailUrl={thumbnailUrl}
                showEstimateTime={false}
            />
        </div>
    );
};

FJAiVideoDubRightStatusBox.propTypes = {
    isShow: PropTypes.bool.isRequired,
    status: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    progress: PropTypes.number,
    generateAllTime: PropTypes.number,
    cancel: PropTypes.func,
    retry: PropTypes.func,
};

export default FJAiVideoDubRightStatusBox;
